import KpiCards from './components/KpiCards';
import PriorityQueue from './components/PriorityQueue';
import TodaySchedule from './components/TodaySchedule';
import TeamStatus from './components/TeamStatus';
import AttentionCenter from './components/AttentionCenter';
import OperationFunnel from './components/OperationFunnel';

export default function Dashboard() {
  const today = new Date();
  const dateLabel = today.toLocaleDateString('tr-TR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  return (
    <div className="mx-auto max-w-[1400px] space-y-6">
      {/* Header */}
      <div className="flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-accent-600">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
            Operasyon Merkezi
          </div>
          <h1 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            Bugün Ne Yapmalıyım?
          </h1>
          <p className="mt-1 text-sm text-foreground-500 capitalize">{dateLabel}</p>
        </div>
        <div className="flex items-center gap-2 rounded-lg border border-background-200 bg-white px-3 py-2 text-sm text-foreground-600">
          <i className="ri-sun-line text-accent-500" />
          <span className="font-semibold">Demo veriler</span>
          <span className="text-foreground-400">·</span>
          <span className="text-foreground-400">26 Ağustos 2026</span>
        </div>
      </div>

      {/* KPI cards */}
      <KpiCards />

      {/* Operation funnel */}
      <OperationFunnel />

      {/* Two column: priority queue + schedule */}
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <PriorityQueue />
        <TodaySchedule />
      </div>

      {/* Attention center + team status */}
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-2">
        <AttentionCenter />
        <TeamStatus />
      </div>
    </div>
  );
}